export default __webpack_public_path__ + "static/media/Group (5).06a46c0e.svg";